import styled from 'styled-components'
import { pxToRem } from '../../utils';
import React from 'react'

const FormErrors = styled.div`
  color: red;
  text-align: center;
  padding: ${pxToRem(10)};
  font-size: ${pxToRem(14)};
`

const AuthErrors = props => {
  const { authError, fetching } = props
  const errors = (((authError || {}).response || {}).data || {}).errors || []

  if (fetching) {
    return null
  }

  if (errors.length) {
    return (
      <FormErrors>
        {errors.map((error, key) => {
          return <span key={key}>{error}</span>
        })}
      </FormErrors>
    )
  }

  if (authError) {
    return (
      <FormErrors>
        <span>Houve um problema na autenticação, tente novamente mais tarde.</span>
      </FormErrors>
    )
  }

  return null
}

export default AuthErrors



// WEBPACK FOOTER //
// ./src/containers/Login/AuthErrors.js